"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkAY2ITIKAcjs = require('./chunk-AY2ITIKA.cjs');

// src/helpers.ts
function dexFactory(config) {
  const { majorVersion, minorVersion } = config;
  if (majorVersion === 1 && minorVersion === 0) {
    return _chunkAY2ITIKAcjs.DEX.v1;
  }
  if (majorVersion === 2 && minorVersion === 1) {
    return _chunkAY2ITIKAcjs.DEX.v2_1;
  }
  if (majorVersion === 2 && minorVersion === 2) {
    return _chunkAY2ITIKAcjs.DEX.v2_2;
  }
  throw new Error(`Unsupported dex version: ${majorVersion}.${minorVersion}`);
}
function routerFactory({
  address,
  majorVersion,
  minorVersion
}) {
  const { Router } = dexFactory({ majorVersion, minorVersion });
  return Router.create(address);
}




exports.dexFactory = dexFactory; exports.routerFactory = routerFactory;
//# sourceMappingURL=chunk-VF72X62M.cjs.map